<template>
  <div class="tabs-status">
    <div
      class="tab"
      :class="{ 'active-tab': index === activeTab }"
      v-for="(tab, index) in tabs"
      :key="index"
      :data-test-id="tab.text"
      @click="handleClick(index)"
    >
      {{ tab.text }}
      <span
        class="tab__meta-value"
        :class="{ 'tab__meta-blur': tab.blur }"
        v-if="meta[tab.value] > 0 && isShowCount"
      >
        ({{ meta[tab.value] }})
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    activeTab: {
      type: Number,
      default: 0
    },
    tabs: {
      type: Array,
      default: () => []
    },
    metaData: {
      type: Array
    },
    onClick: {
      type: Function
    },
    isShowCount: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    meta() {
      const result = {}

      if (this.metaData && this.metaData.length > 0) {
        let all = 0

        this.metaData.forEach((m) => {
          if (m._id) {
            result[m._id] = m.count || 0

            all += result[m._id]
          }
        })

        if (all > 0) {
          result.ALL = all
        }
      }

      return result
    }
  },
  methods: {
    handleClick(index) {
      this.$emit('onClick', index)
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs-status {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  overflow-x: auto;

  .tab {
    margin: 0 12px;
    line-height: 36px;
    padding-bottom: 4px;
    text-align: center;
    white-space: nowrap;
    cursor: pointer;
    color: #142246;

    .tab__meta-value {
      color: #f44336;

      &.tab__meta-blur {
        color: #7a8189;
      }
    }

    &.active-tab {
      font-weight: 500;
      color: #ff8200;
      border-bottom: 2px solid #ff8200;

      .tab__meta-value {
        color: #ff8200;
      }
    }
  }
}
</style>
